import { Maintenance } from 'models/Maintenance';
import { MachineType } from './MachineType';
import { MachinePart } from './MachinePart';

export type MachineMaintenancePart = {
    machinePart: MachinePart;
    quantity: number;
}

export class MachineMaintenance {
    id: number;
    machineType: MachineType;
    maintenance: Maintenance;
    intervalServiceLife: number;
    warningThresholdServiceLife: number;
    intervalDays: number;
    warningThresholdDays: number;
    parts?: MachineMaintenancePart[] | null; // null on save keeps the stored parts
    archivedDate?: Date;

    constructor(
        id: number,
        machineType: MachineType,
        maintenance: Maintenance,
        intervalServiceLife: number,
        warningThresholdServiceLife: number,
        intervalDays: number,
        warningThresholdDays: number,
        parts?: MachineMaintenancePart[] | null,
        archivedDate?: Date
    ) {
        this.id = id;
        this.machineType = machineType;
        this.maintenance = maintenance;
        this.intervalServiceLife = intervalServiceLife;
        this.warningThresholdServiceLife = warningThresholdServiceLife;
        this.intervalDays = intervalDays;
        this.warningThresholdDays = warningThresholdDays;
        this.parts = parts;
        this.archivedDate = archivedDate;
    }

    static empty(): MachineMaintenance {
        return { 
            id: 0,
            machineType: MachineType.empty(),
            maintenance: Maintenance.empty(),
            intervalServiceLife: 0,
            warningThresholdServiceLife: 0,
            intervalDays: 0,
            warningThresholdDays: 0,
            parts: []
        };
    }

}